import { FC, memo, useState } from 'react';
import { styled } from '@robocorp/theme';
import { ViewLoader } from '~/components';
import { withErrorBoundary } from '~/hocs';
import { useArtifactLink } from '../hooks/useArtifactLink';

const IFrame = styled('iframe')<{ isLoaded: boolean }>`
  visibility: ${({ isLoaded }) => (isLoaded ? 'visible' : 'hidden')};
  display: flex;
  flex: 1;
`;

interface Props {
  processId: string;
  processRunId: string;
  activityRunId: string;
}

const LogArtifact: FC<Props> = withErrorBoundary(({ processId, processRunId, activityRunId }) => {
  const [isContentLoaded, setIsContentLoaded] = useState(false);

  const { data: logArtifactLink, isLoading: isArtifactLinkLoading } = useArtifactLink(
    processId,
    processRunId,
    activityRunId,
  );

  const hasLogArtifact = !!logArtifactLink;
  const isLoading = isArtifactLinkLoading || !isContentLoaded;

  return (
    <>
      {isLoading && <ViewLoader />}
      {hasLogArtifact && (
        <IFrame
          title="Logs"
          src={logArtifactLink}
          width="100%"
          height="100%"
          isLoaded={isContentLoaded}
          onLoad={() => setIsContentLoaded(true)}
          sandbox="allow-scripts"
        />
      )}
    </>
  );
});

export const WorkItemLogArtifact = withErrorBoundary(memo(LogArtifact));
